import React from 'react';
import CopyableIdCell from '../common/CopyableIdCell';

/**
 * ChallanNumberCell — fees-domain alias for the generic CopyableIdCell.
 * Kept as its own export so fee screens read naturally ("challan number"),
 * but all copy-on-click behaviour lives in one place.
 */
type Props = React.ComponentProps<typeof CopyableIdCell>;

const ChallanNumberCell: React.FC<Props> = (props) => <CopyableIdCell {...props} />;

export default ChallanNumberCell;
